import {useState} from 'react'
import {Package, X} from 'lucide-react'

export function IconEditor({value}: {value: string; onChange?: (value: string) => void}) {
  const [previewURL, setPreviewURL] = useState('')
  return (
    <>
      <div className="icon-editor page">
        {value ? (
          <button type="button" className="media-image-button" onClick={() => setPreviewURL(value)} aria-label="查看 Icon 大图">
            <img src={value} alt="" />
          </button>
        ) : (
          <span className="media-placeholder"><Package size={22} /></span>
        )}
      </div>
      <ImagePreviewOverlay url={previewURL} onClose={() => setPreviewURL('')} />
    </>
  )
}

export function PreviewImages({raw}: {raw: string}) {
  const urls = parsePreviewURLs(raw)
  if (!urls.length) return <span>-</span>
  return (
    <div className="preview-strip">
      {urls.map((url) => <img key={url} src={url} alt="" />)}
    </div>
  )
}

export function EditablePreviewImages({value}: {value: string; onChange?: (value: string) => void}) {
  const [previewURL, setPreviewURL] = useState('')
  const urls = parsePreviewURLs(value)
  return (
    <>
      <div className="preview-editor">
        {urls.length ? (
          <div className="preview-strip editable">
            {urls.map((url) => (
              <button type="button" className="preview-card" key={url} onClick={() => setPreviewURL(url)} aria-label="查看预览图大图">
                <img src={url} alt="" />
              </button>
            ))}
          </div>
        ) : (
          <div className="preview-empty">暂无预览图</div>
        )}
      </div>
      <ImagePreviewOverlay url={previewURL} onClose={() => setPreviewURL('')} />
    </>
  )
}

function ImagePreviewOverlay({url, onClose}: {url: string; onClose: () => void}) {
  if (!url) return null
  return (
    <div className="image-preview-backdrop" onMouseDown={onClose}>
      <div className="image-preview-dialog" onMouseDown={(event) => event.stopPropagation()}>
        <button type="button" className="image-preview-close" onClick={onClose} aria-label="关闭大图预览">
          <X size={18} />
        </button>
        <img src={url} alt="" />
      </div>
    </div>
  )
}

function parsePreviewURLs(raw: string) {
  const trimmed = raw.trim()
  if (!trimmed) return []
  try {
    const parsed = JSON.parse(trimmed)
    if (Array.isArray(parsed)) {
      return parsed.filter((item): item is string => typeof item === 'string' && item.trim() !== '')
    }
  } catch {
    // Fall back to newline-separated values for manual edits.
  }
  return trimmed.split(/\n+/).map((item) => item.trim()).filter(Boolean)
}
